var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPitcairnIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e44",
    d: "M24.86 11.73c0 .45-.51.82-1.15.82s-1.16-.37-1.16-.82c0-.46.52-.82 1.16-.82s1.15.36 1.15.82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a67",
    d: "M19.59 10.45c0 .4 1.17.85 2.1-.3.95-1.14.67.41.29.66-.39.24-.8.82-1.63.73s-1.04-.42-1.23-.9c-.2-.48.47-.19.47-.19"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "M19.76 8.01a.46.46 0 0 1-.25.6l-.86.35a.46.46 0 1 1-.35-.85l.86-.35a.46.46 0 0 1 .6.25m7.35 2.6c-.14.21-.39.3-.55.19l-1.21-.8c-.17-.1-.2-.36-.05-.58.13-.21.38-.3.55-.19l1.2.78c.17.11.2.37.06.59"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "M27.26 10.32a.46.46 0 0 1-.88.25l-.5-1.78a.46.46 0 0 1 .89-.24z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "M27.64 10.53a.46.46 0 1 1-.92 0 .46.46 0 0 1 .92 0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a67",
    d: "M19.83 10.32c0 .19-.21.34-.46.34-.26 0-.47-.15-.47-.34V8.24c0-.19.21-.34.47-.34.25 0 .46.15.46.34z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a67",
    d: "M20.49 9.36c.15.2.15.46 0 .57l-1.1.82c-.14.12-.39.04-.54-.16s-.16-.46 0-.57l1.09-.82c.15-.12.4-.04.55.16"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a67",
    d: "M19.4 10.3c0 .26-.22.46-.5.46-.27 0-.49-.2-.49-.45s.22-.46.5-.46c.27 0 .49.2.49.46m8.58-1.48c-.1.24-.6.25-1.13.03-.52-.23-.86-.6-.76-.84s.6-.25 1.13-.02c.52.22.86.6.76.83"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d5d6",
    d: "M22.41 9.05c-.53.35-1.25 1-1.25 1l.4.05s.49.5.57 1c.09.48-.1.15-.15.52a1 1 0 0 0 .17.63s.58-.2.96-.49.64-.73.85-.5c.22.22.2.33.2.33h.28s-.47-.46-.46-.72-.41-1.56-.41-1.56zm-.63-1.16.4-.29c-.05.04.5.23.82.1.33-.14.97-.79 1.13-.69s-.8.65-.4.74.52-.25.77-.37.63-.13.26.11c-.37.25-.88 1.31-.88 1.31l-1.5-.11-.4-.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a67",
    d: "M24.35 9c0 .22-.56.4-1.24.4s-1.24-.18-1.24-.4c0-.2.56-.38 1.24-.38s1.24.17 1.24.39m-4.1 4.56c-.06.2-.52.24-1.03.08-.5-.16-.86-.45-.8-.66.07-.2.53-.23 1.04-.07.5.16.86.45.8.65m7.02 1.5c-.03.16-.49.2-1.02.11-.54-.09-.95-.3-.93-.45.03-.16.49-.2 1.02-.11.54.1.96.3.93.45"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a67",
    d: "M26.36 15.14c-.15.7-.4 1.23-.55 1.2s-.17-.62-.02-1.32.39-1.24.55-1.2c.15.03.16.62.02 1.32m-2.32-6.01c.25.66.97 1.96 1.65 1.97s.77-.28.77-.28.02.51-.6.61-.97-.21-.85-.1c.1.1.36.34.94.5.57.14 1.56.32 1.53.87-.03.56-.41.77-.37.53.03-.25-.4-.69-1.16-.86a2.5 2.5 0 0 1-2-1.82c-.38-1.24-.08-.12-.08-.12s-.74.23-.74-.14.58-.18.46-.65-.4-.8-.12-.7zm-1.88 1.69c-.37.57-1.46 1.38-1.81 1.76s-.6 1.1-.68 1.58c-.08.47.07 1.2.33.38.27-.82.74-1.14 1.21-1.67.48-.53.8-.89.98-1.24.17-.36-.03-.81-.03-.81"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "M24.4 11.2c.11.4.1.74-.03.78s-.33-.24-.45-.63-.1-.73.03-.77.33.24.44.63m-3.27 0c0 .12-.28.21-.63.21s-.64-.1-.64-.2c0-.13.29-.22.64-.22s.63.1.63.21m-1.01 3.82c.13.71.11 1.32-.05 1.35s-.4-.52-.54-1.24c-.13-.7-.11-1.31.05-1.34s.4.52.54 1.23"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "M20.58 14.9c0 .13-.4.25-.9.25s-.92-.12-.92-.26.41-.26.91-.26.91.12.91.26m.21 2.01c.17.35.22.69.1.75-.11.05-.35-.18-.53-.54-.17-.35-.22-.68-.1-.74s.36.18.53.53m5 .23c-.25.36-.6.56-.76.45s-.1-.52.15-.88c.26-.37.6-.57.77-.45s.1.51-.15.88m2.1-4.24c.12.19-.22.6-.77.94-.54.33-1.08.45-1.2.26-.1-.19.24-.6.79-.94.54-.33 1.07-.45 1.19-.26m-9.31-.2c.25-.6 1.06-.93 1.59-1.07s.65-.3 1.08-.64.33-.57.54-.41c.2.15.38.22.18.5-.2.3-.9.9-1.37 1.07a8 8 0 0 0-1.4.66c-.07.1-.71.1-.62-.1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d8fcc",
    d: "M20.64 11.76h4.4v3.35c0 1.43-2.2 2.9-2.2 2.9s-2.2-1.44-2.2-2.97z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a67",
    d: "m24.76 16.03-1.9-3.76-2.04 3.53c.51 1.21 2.02 2.22 2.02 2.22s1.34-.91 1.92-2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "m20.81 15.56.15.36 1.9-3.45 1.85 3.42.15-.38-1.96-3.75zm4.13-3.44c.3.5.86.35 1.1 1.2.25.86.12 1.79-.13 1.05-.26-.73-.33-1.14-1.05-1.33-.71-.19.08-.92.08-.92m-4.6 4.42-.17 1.07.96-.5zm5.11.17-.9.42.99.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "M23.75 15.1a.17.17 0 0 1-.18.17h-1.34a.2.2 0 0 1-.17-.1.2.2 0 0 1 .04-.2.2.2 0 0 1 .13-.04h1.34q.16.02.18.17"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "M22.99 16.88c0 .13-.04.24-.08.24h-.14c-.04 0-.08-.11-.08-.24v-2.29c0-.13.04-.24.08-.24h.14q.07.02.08.24z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "m21.72 16.04.53.56-.09.12.6.4.84-.4-.18-.11.6-.46-.08.77-.22-.06-.87.73-.92-.78-.17.02z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitcairnIslands);
export default __webpack_public_path__ + "static/media/pitcairn-islands.7de56a2e56f03e3282bf2c42c1e50af0.svg";
export { ForwardRef as ReactComponent };